import { render, staticRenderFns } from "./LexonKanbanComponent.vue?vue&type=template&id=3221e11c&scoped=true&lang=pug"
import script from "./LexonKanbanComponent.vue?vue&type=script&lang=ts"
export * from "./LexonKanbanComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexonKanbanComponent.vue?vue&type=style&index=0&id=3221e11c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3221e11c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3221e11c')) {
      api.createRecord('3221e11c', component.options)
    } else {
      api.reload('3221e11c', component.options)
    }
    module.hot.accept("./LexonKanbanComponent.vue?vue&type=template&id=3221e11c&scoped=true&lang=pug", function () {
      api.rerender('3221e11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LexonKanban/LexonKanbanComponent.vue"
export default component.exports